'use strict';

var util = require('../../util');
var shipping = require('./shipping');
var formPrepare = require('./formPrepare');

/**
 * @private
 * @description return function that detach/attach postal field and show/hide zip field based on country selected
 * @return function
 */
var updatePostalFieldHandler = function ($form) {
	var postalField = $form.find('[name$="postal"]'),
		postalContainer = postalField.closest('.field-wrapper'),
		zipField = $form.find('[name$="_zip"]'),
		zipFieldContainer = zipField.closest('.field-wrapper');

		return function (country, clearValues) {
			if (country === 'GB') {
				zipField.detach();
				zipFieldContainer.closest('.form-row').hide();
				postalField.appendTo(postalContainer);
				postalContainer.closest('.form-row').show();
			} else {
				postalField.detach();
				postalContainer.closest('.form-row').hide();
				zipField.appendTo(zipFieldContainer);
				zipField.closest('.form-row').show();
			}
			//clear values
			if (clearValues) {
				zipField.val('');
				postalField.val('');
			}
		};
};
/**
 * @private
 * @description update state dropdown/county form elements on country changed
 * if dropdown has options, preselect the first option and make it mandatory,
 * otherwise hide and set as optional
 */
var updateStatesOption = function ($form, countryCode) {
	var countryObj = window.Countries[countryCode],
		$stateCodeField = $form.find('input[name$="_county"]'),
		$statesDropDown = $form.find('select[name$="_state"]'),
		statesOptions = [];
	if (!countryObj) {
		return;
	}
	if (!countryObj.regions) {
		$stateCodeField
			.val('')
			.closest('.form-row').show();
		$statesDropDown
			.removeClass('required')
			.closest('.form-row').removeClass('required').hide();

	} else {
		$stateCodeField.closest('.form-row').hide();
		statesOptions.push('<option value="">' + countryObj.regionLabel + '</option>');
		for (var s in countryObj.regions) {
			statesOptions.push('<option value="' + s + '">' + countryObj.regions[s] + '</option>');
		}
		$statesDropDown
			.html(statesOptions)
			.addClass('required')
			.find('option:first').prop('selected', 'selected');
		$statesDropDown.closest('.form-row').addClass('required').show();
		$statesDropDown.trigger('change');
		$form.find('select').uniform();
	}
};

/**
 * @function
 * @desc update dynamic address form fields on load and assign necessary event handlers to handle
 * dynamic form fields every time country changed
 */
exports.dynamicAddressFieldsHandler = function ($form) {
		var defaultCountry = $form.find('select[name$="country"]').val(),
			defaultStateCode = $form.find('[name$="_county"]').val(),
			updatePostalField = updatePostalFieldHandler($form);

		$('select[name$="_country"]').on('change', function () {
			var countryCode = $(this).val();
			updateStatesOption($form, countryCode);
			updatePostalField(countryCode, true);
		});

		//event handler for states dropdown to update hidden stateCode when dropdown is visible
		$form.on('change', 'select[name$="_state"]', function () {
			$form.find('input[name$="_county"]').val($(this).val());
		});

		//update postalcode/zip and states/county on load
		updateStatesOption($form, defaultCountry);
		updatePostalField(defaultCountry, false);

		//select default state option or update county field, if stateCode exists in Address Object
		if (defaultStateCode && window.Countries[defaultCountry].regions) {
			$form.find('select[name$="_state"]').val(defaultStateCode)
				.trigger('change');
		} else if (defaultStateCode) {
			$form.find('[name$="_county"]').val(defaultStateCode);
		}

		if ($form.hasClass('checkout-address-form')) {
			formPrepare.init({
				continueSelector: '[name$="_editAddress_save"]',
				formSelector: '.checkout-address-form',
				keyup: true,
				replaceInvalidInput: true,
				autofillValidate: true
			});
		}
};

/**
 * @function
 * @description Selects the first address from the list of addresses
 * update shipping methods based on address selected (applicable to the single shipping scenario)
 */
exports.deliveryAddressChangeHanlder = function () {

	var $form = $('.address');
	$('select[name$="_addressList"]', $form).on('change', function () {
		var selected = $(this).children(':selected').first();
		var selectedAddress = $(selected).data('address');
		if (!selectedAddress) { return; }
		util.fillAddressFields(selectedAddress, $form);
		shipping.updateShippingMethodList();
		shipping.clearShutlQuoteId();
		// re-validate the form
		$form.validate().form();
	});
};

/**
 *@private
 * resets  position of pca lists in IE 10/11 address dialogs,
 * after moving pca into the dialog, @see pcaDialogIEFix.
 */
var getRightPositionForPCA = function ($pca, dialogClass) {
	var $pcaAutocomplete = $pca.find('.pcaautocomplete').not('.pcacountrylist'),
		dialogOffset = $(dialogClass).offset().top + 10;
	$pcaAutocomplete.css('margin-top', '-' + dialogOffset + 'px');
	$(window).smartresize(function () {
		dialogOffset = $(dialogClass).offset().top + 10;
		$pcaAutocomplete.css('margin-top', '-' + dialogOffset + 'px');
	});
};

/**
 * IE 10/11, relocate pca into the dialog to fix click event is not dispatched
 */
exports.pcaDialogIEFix = (function () {
	var pcaNotLoaded = 0,
		relocatePCA = function (dialogClass) {
			var $pca = $('body').children('.pca');
			if (window.navigator.userAgent.indexOf('Trident') !== -1) {
				if ($pca.length === 1) {
					$(dialogClass).find('.pca').remove();
					$(dialogClass).append($pca);
					getRightPositionForPCA($pca, dialogClass);
				} else if (pcaNotLoaded < 20) {
					pcaNotLoaded++;
					setTimeout(function () {
						relocatePCA(dialogClass);
					}, 100);
				}
			}
		};

	return relocatePCA;
})();
